<!--课程的详情页-->
<!----wj-->
<template>
  <div class="tscsdetail">
    <detail-title></detail-title>
    <!--视频组件-->
    <div id="tsd-top" class="tsd-top">
      <video-bar v-show="video"></video-bar>
      <!--office组件-->
      <office-bar v-show="office" class="Tsoc"></office-bar>
      <img v-if="showPic" :src="tsbanner.tsocLogo" class="morenPic" />
    </div>
    <div style="padding-top:73vw;padding-bottom:2rem">
      <!-- 介绍 -->
      <div class="d_jump" id="first">
        <div class="tsd-js">
          <p class="offline-title">
            <strong>{{tsbanner.tsocName}}</strong>
          </p>
          <p class="tsd-teach">{{tsbanner.sysDate}}</p>
        </div>
      </div>
      <div class="tsd-line"></div>
      <!-- 目录 -->
      <div class="d_jump" id="second">
        <p class="offline-jj"><strong>目录</strong></p>
        <div class="listpic">
          <div
            class="listpic-col"
            v-for="item in list.slice(0,listLength)"
            :key="item.tscsId"
            @click="IndexClick($event,item)">
            <el-col :span="3"  v-if="item.tscsType !='视频'">
              <div class="ts-dp">文档</div>
            </el-col>
            <el-col :span="3"  v-if="item.tscsType =='视频'">
              <div class="ts-dp">视频</div>
            </el-col>
            <el-col :span="21" class="listpic-row" style="padding-left:1rem;">
              <div class="listpic-p" :class="{'tsd-choose':choose==item.tscsId}">{{item.tscsName}}</div>
            </el-col>
          </div>
        </div>
        <div v-if="list.length>3">
          <p @click="MoreIndex()" v-if="showIndex" style="padding:10px 0;text-align:center">展开<i class="el-icon-arrow-down"></i></p>
          <p @click="MoreIndex()" v-else style="padding:10px 0;text-align:center">收起<i class="el-icon-arrow-up"></i></p>
        </div>
      </div>
      <div class="tsd-line"></div>
      <p class="offline-jj"><strong>课程简介</strong></p>
      <div class="offline-detail">
        <p class="offline-intro" v-html="tsbanner.tsocDesc">{{tsbanner.tsocDesc}}</p>
      </div>
      <div class="tsd-line" v-if="offList"></div>
      <p class="offline-jj" v-if="offList"><strong>授课老师</strong></p>
      <div  class="tstt-wapper" v-if="offList" :class="showprice?'ts-bottom':''">
        <p class="tstt-p"><img :src="offList.tsttPic" :onerror="tslogo" class="tstt-logo">
        <span style="padding-left:1rem;">{{offList.tsttName}}</span></p>
        <p :class="tstt?'tstt-name':'tstt-nana'"  v-html="offList.tsttDesc">{{offList.tsttDesc}}</p>
        <p class="tstt-more" v-if="offList.desclength">
          <span @click="More()" v-if="tstt">展开<i class="el-icon-arrow-down"></i></span>
          <span  @click="Less()" v-if="!tstt">收起<i class="el-icon-arrow-up"></i></span>
        </p>
      </div>
    </div>
    <el-row class="Offline-footer" v-if="tsbanner.tsocPrice !='免费'">
        <el-col :span="8">
            <p class="off-fire" style="padding-top: 0.5rem;"> ￥<span style="font-size:1.8rem;"><strong>{{tsbanner.tsocPrice}}</strong></span></p>
        </el-col>
        <el-col :span="8" class="off-zixun">
            <a v-bind:href="phone"><img src="@/assets/image/tell3.svg" class="Off-tel">咨询</a>
            <span style="color:rgb(230,232,232);">|</span>
        </el-col>
        <el-col :span="8">
            <button  type="button"  class="Offline-btn2" @click="OpenStore()">前往app观看</button>
        </el-col>
    </el-row>
    <share-wechat></share-wechat>
  </div>
</template>
<script>
import VideoBar from "@/components/VideoBar";
import OfficeBar from "@/components/OfficeBar";
import DetailTitle from "@/components/DetailTitle";
import Axios from "axios";
import $ from "jquery";
import { eventBus } from "@/assets/js/eventBus";
import ShareWechat from "@/components/ShareWechat";
export default {
  data() {
    return {
      activeName: "0",
      list: [],
      offList: [],
      video: false,
      TsocLogo: true,
      office: false,
      logo: 'this.src="' + require("@/assets/image/gg1.jpg") + '"',
      showPic: true,
      type: 1,
      tslogo:'this.src="' + require("@/assets/image/tx3.svg") + '"', //专家默认图片
      logo: 'this.src="' + require("@/assets/image/gg1.jpg") + '"',
      listpic: [], //数据列表
      choose: "",
      width: "",
      tabtDis: "",
      tabsDis: "",
      phone:"tel:400-829-6689",
      tsbanner:[],
      showprice:true,
      tstt:true,
      showIndex:true,
      listLength:'3'
    };
  },
  components: {
    VideoBar,
    OfficeBar,
    DetailTitle,
    ShareWechat
  },
  mounted() {
    const that = this;
    var id = "";
    var locations = location.href;
    if (locations.indexOf("?") != -1) {
      //判断是否有参数
      if (locations.indexOf("from") != -1) {
        var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        var strs = str.split("?");
        id = strs[2];
      } else {
        var str = locations.substr(0); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
        var strs = str.split("?");
        id = strs[1]; //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
      }
    }
    that.getoffLists(id);
    that.getLists(id);
    that.width = parseInt(($(window).width() / 100) * 90);
  },
  methods: {
    // https获取简介数据
    getoffLists(id) {
      const that = this;
      Axios.get(that.$store.state.APIURLS + "Tsoc/findByIdV228?" + id).then(function(res) {
          if (res.data.code == 200) {
            if (res.data.data.tsoc.tsocPrice == "0.00" || res.data.data.tsoc.tsocPrice == "0") {
              res.data.data.tsoc.tsocPrice = "免费";
                that.showprice = false;
            }else{
              that.showprice = true;
            }
            if (res.data.data.tsoc.sysDate) {
              res.data.data.tsoc.sysDate = that.dates.handleDate(res.data.data.tsoc.sysDate);
            }
            if(res.data.data.tstt){
              if(res.data.data.tstt.tsttDesc.length>=65){
                res.data.data.tstt.desclength = true;
              }else{
                res.data.data.tstt.desclength = false;
              }
            }
            that.tsbanner = res.data.data.tsoc;
            that.offList = res.data.data.tstt;
            var shareList = {
                title: res.data.data.tsoc.tsocName,
                content: res.data.data.tsoc.tsocDesc,
            };
            eventBus.$emit("shareList", shareList);
          }
        }
      );
    },
    // https获取目录信息
    getLists(id) {
      const that = this;
       Axios.get(that.$store.state.APIURLS + "Tscs/findOcByEs?tsocId=" + id).then(
        function(res) {
          if (res.data.code == 200) {
            that.tabtDis = $("#first").height();
            that.tabsDis = $("#second").height() + $("#first").height();
            that.list = res.data.data;
          }
        }
      );
    },
    IndexClick(event,m) {
      const that = this;
      that.choose = m.tscsId;
      if(that.tsbanner.tsocPrice != "免费"){
        that.$toast({message: "付费项目,请前往APP", type: "success",position: "bottom",duration: "2000"});
      }else{
        if (m.tscsType == "视频") {
          that.video = true;
          that.office = false;
          that.showPic = false;
          var t = {
            url: m.tscsFile,
          }
          eventBus.$emit("fileUrl",t);
        } else {
          that.showPic = false;
          that.video = false;
          that.office = true;
          var t = {
            url: m.tscsFile,
          }
          eventBus.$emit("pptUrl", t);
        }
      }
    },
    //更多
    More(){
      var that = this;
      that.tstt = false;
    },
    MoreIndex(){
      var that = this;
      that.showIndex = !that.showIndex
      if(that.showIndex){
        that.listLength = 3
      }else{
        that.listLength = 99
      }
    },
    //减少
    Less(){
      var that = this;
      that.tstt = true;
    },
    OpenStore() {
      const that = this;
      location.href='http://url.cn/59TtsAP';
    }
  },
};
</script>
<style>
</style>